import React from "react";
import Head from "next/head";

import TermsOfUseMain from "@/components/terms-of-use/terms-of-use-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const TermsOfUse = () => {
  return (
    <>
      <Head>
        <title>{seoData.TERMS_OF_USE.title}</title>
        <SeoMetaData data={seoData.TERMS_OF_USE} />
      </Head>

      <TermsOfUseMain />
    </>
  );
};

export default TermsOfUse;
